import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Paper,
  Box,
  Checkbox,
  IconButton,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
  Tooltip,
  TextField,
  Button,
  Dailog,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Cookie from "js-cookie";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { useMaterialUIController } from "context";
import {
  StyledTypography,
  StyledAgGridContainer,
  StyledSnackbar,
  StyledAlert,
  DeleteButton,
  StyledButton,
  inputStyle,
} from "components/StyledComponents/styledComponents.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import URLs from "constants/urls";
import CurrencyInput from "react-currency-input-field";
import { ViewButton } from "components/StyledComponents/styledComponents";
import { CustomPaper } from "components/Styles/globalStyles";
import LoanPopover from "./dataView";

export default function SpotPayment() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [advanceEligibleData, setAdvanceEligibleData] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [dsaData, setDsaData] = useState([]);
  const jwt_token = Cookie.get("jwt_token");
  const [selectedDSA, setSelectedDSA] = useState("All");
  const MInput = inputStyle();
  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [confirmData, setConfirmData] = useState(null);

  const handleView = (data, event) => {
    setSelectedRow(data);
    setAnchorEl(event.currentTarget); // Open popover on icon click
  };
  const handleClosePopOver = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  const [selectedBank, setSelectedBank] = useState(null);
  useEffect(() => {
    fetchAdvanceEligibleData();
    fetchBankAccountsData();
    fetchDsaMasterData();
    fetchAdvanceEligibleData();
  }, []);
  useEffect(() => {
    const defaultBank = bankAccounts.find((bank) => bank.isDefault === "Y") || bankAccounts[0];
    setSelectedBank(defaultBank);
  }, []);
  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const fetchAdvanceEligibleData = async () => {
    try {
      let url =
        selectedDSA == "All"
          ? URLs.spotPaymentsEligibleEntries
          : `${URLs.spotPaymentsEligibleEntries}/${selectedDSA}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const filteredData = data.map((item) => {
        return {
          ...item,
          amountPaid: item.subDsaPaymentAmount,
        };
      });
      setAdvanceEligibleData(filteredData);
    } catch (error) {
      setAlert("Error fetching data", "error");
    }
  };
  const fetchBankAccountsData = async () => {
    setLoading(true);
    const url = `${URLs.bankAccountsByDsaId}/0`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setBankAccounts(data);
    } catch (error) {
      setAlert("Failed to fetch bank accounts", "error");
    }
    setLoading(false);
  };
  const fetchDsaMasterData = async () => {
    if (!jwt_token) {
      setAlert("Missing authorization token", "error");
      return;
    }

    const url = URLs.dsaMasterGetUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }

      const data = await response.json();

      const filteredDsaData = [...data.data, { dsaId: "All", dsaName: "Select All" }].sort((a, b) =>
        a.dsaName.localeCompare(b.dsaName)
      );
      setDsaData(filteredDsaData);
    } catch (error) {
      console.error("Fetch error:", error);
      setAlert(`Failed to fetch data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (data) => {
    if (!selectedBank) {
      setAlert("Please select a bank account", "error");
      return;
    }
    setConfirmData(data);
    setOpenConfirmBox(true);
  };
  const handleCloseDialog = () => {
    setOpenConfirmBox(false);
    setConfirmData(null);
  };
  const handleConfirmPayment = async () => {
    if (!confirmData) return;
    if (!confirmData.amountPaid) {
      setAlert("Please enter the amount to be paid", "error");
      return;
    }
    const url = `${URLs.advanceConfirmation}`;
    const options = {
      paymentId: 0,
      companyId: confirmData.dsaId,
      entryId: confirmData.entryId,
      date: new Date().toISOString().split("T")[0],
      advancePayment: confirmData.amountPaid,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(options),
      });

      if (response.ok) {
        setAlert(`Payment Voucher created`);
        fetchAdvanceEligibleData();
      } else {
        setAlert(`Failed to create Payment voucher`, "error");
      }
    } catch (error) {
      setAlert("An error occurred while submitting payment", "error");
    } finally {
      handleCloseDialog();
    }
  };
  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);
  };
  const columnDefs = [
    {
      headerName: "Actions",
      field: "actions",
      width: 80,
      cellRenderer: (params) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="View Full Details" arrow>
            <IconButton type="button" onClick={(event) => handleView(params.data, event)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sorted: true,
      width: 130,
      valueFormatter: (params) => {
        const date = new Date(params.value); // Convert the timestamp to a Date object
        const day = date.getDate().toString().padStart(2, "0"); // Get day with leading zero
        const month = date.toLocaleString("default", { month: "short" }); // Get month as short name
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Return in "dd-MMM-yyyy" format
      },
      sort: "desc",
    },
    { headerName: "App No", field: "applicationNumber", sortable: true, filter: true, flex: 1 },
    { headerName: "Customer Name", field: "customerName", sortable: true, filter: true, flex: 1 },
    {
      headerName: "Revenue (%)",
      field: "grossPayoutPercent", // This won't work directly for nested objects
      valueGetter: (params) => params.data?.grossPayoutPercent ?? "",
      filter: true,
      sortable: true,
      maxWidth: 130,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
    },
    {
      headerName: "Revenue",
      field: "grossPayoutAmount",
      sortable: true,
      filter: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" }, // Aligns the text to the right
      valueFormatter: (params) =>
        `₹ ${params.value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    { headerName: "DSA Name", field: "dsaName", sortable: true, filter: true, flex: 1 },
    {
      headerName: "DSA Payout (%)",
      field: "dsaPayoutPercent",
      valueGetter: (params) => params.data.dsaPayoutPercent,
      filter: true,
      sortable: true,
      maxWidth: 150,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
    },
    {
      headerName: "DSA Payout",
      field: "dsaPayoutAmount",
      sortable: true,
      filter: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" }, // Aligns the text to the right
      valueFormatter: (params) =>
        `₹ ${params.value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    {
      headerName: "Connector (%)",
      field: "dsubDsaPayoutPercent",
      valueGetter: (params) => params.data.subDsaPayoutPercent,
      filter: true,
      sortable: true,
      maxWidth: 150,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
    },
    {
      headerName: "Amount Paid",
      field: "amountPaid",
      cellStyle: { padding: 0 },
      cellRenderer: (params) => {
        const [inputValue, setInputValue] = useState(params.value ? String(params.value) : "");

        // Synchronize input with external data changes
        useEffect(() => {
          if (params.value !== inputValue) {
            setInputValue(params.value ? String(params.value) : "");
          }
        }, [params.value]);

        // Handle input blur (update AG Grid data on blur)
        const handleBlur = () => {
          const numericValue = parseFloat(inputValue.replace(/[^0-9.]/g, ""));
          params.data.amountPaid = !isNaN(numericValue) ? numericValue : 0;
          params.api.refreshCells({ rowNodes: [params.node] });
        };

        // Update input value locally
        const handleValueChange = (value) => {
          setInputValue(value || "");
        };

        return (
          <TextField
            variant="outlined"
            fullWidth
            value={inputValue}
            onBlur={handleBlur}
            InputProps={{
              inputComponent: CurrencyInput,
              inputProps: {
                decimalsLimit: 2,
                prefix: "₹ ",
                decimalSeparator: ".",
                groupSeparator: ",",
                value: inputValue,
                onValueChange: handleValueChange,
                intlConfig: { locale: "en-IN" },
                allowNegative: false, // Disallow negative values
              },
            }}
            sx={{
              height: "100%",
              "& .MuiInputBase-root": {
                height: "100%",
              },
            }}
          />
        );
      },
      flex: 1,
    },
    {
      headerName: " ",
      field: "submit",
      width: "100px",
      cellRenderer: (params) => (
        <ViewButton
          variant="contained"
          color="primary"
          size="small"
          type="button"
          onClick={() => handleOpenDialog(params.data)}
        >
          Submit
        </ViewButton>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <Dialog open={openConfirmBox} onClose={handleCloseDialog}>
        <DialogContent sx={{ mt: 1, ...subDialogContentStyle }}>
          <DialogContentText sx={dialogContentTextStyle}>
            Are you sure you want to submit payment of ₹
            {Number(confirmData?.amountPaid).toLocaleString("en-IN")}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleCloseDialog} color="secondary">
            Cancel
          </StyledButton>
          <StyledButton onClick={handleConfirmPayment} color="primary">
            Confirm
          </StyledButton>
        </DialogActions>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "flex-start",
            mr: 1,
          }}
        >
          <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
            <Autocomplete
              options={bankAccounts}
              getOptionLabel={(option) => `${option.bankName} - ${option.accountNumber}`}
              value={selectedBank}
              onChange={handleBankChange}
              PaperComponent={CustomPaper}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Bank"
                  sx={{
                    height: 43,
                    ...MInput.b,
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: 43,
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                      "&.Mui-focused": {
                        color: "red",
                      },
                    },
                  }}
                />
              )}
            />
          </FormControl>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: "flex-start",
              minWidth: "200px",
              maxWidth: "300px",
              width: "100%",
            }}
          >
            <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "300px" }}>
              <Autocomplete
                options={dsaData}
                fullWidth
                required
                getOptionLabel={(option) => option.dsaName}
                value={dsaData.find((item) => item.dsaId === selectedDSA) || null}
                onChange={(event, value) => setSelectedDSA(value ? value.dsaId : "")}
                disableClearable={false}
                filterOptions={(options, state) => {
                  const input = state.inputValue.toLowerCase();
                  return options.filter(
                    (option) =>
                      option.dsaName.toLowerCase().startsWith(input) ||
                      option.dsaName.toLowerCase().includes(input)
                  );
                }}
                PaperComponent={CustomPaper}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select DSA"
                    variant="outlined"
                    required
                    sx={{
                      width: "100%",
                      ...MInput.b,
                      "& .MuiInputBase-root": {
                        height: 42,
                        flexGrow: 1,
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "14px",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        color: MInput.a,
                        "&.Mui-focused": {
                          color: "red",
                        },
                      },
                    }}
                  />
                )}
              />
            </FormControl>
            <StyledButton onClick={fetchAdvanceEligibleData}>Go</StyledButton>
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          {selectedRow && (
            <LoanPopover data={selectedRow} anchorEl={anchorEl} onClose={handleClosePopOver} />
          )}
          <StyledAgGridContainer component={Paper} className="ag-theme-alpine">
            <AgGridReact
              rowData={advanceEligibleData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
            />
          </StyledAgGridContainer>
        </Box>
      </Box>
    </DashboardLayout>
  );
}
